import { IconDesktop, Link, PageFooter, Text, VStack } from '@direct-frontend/components';
import { KIT_SUPPORT_URL } from '#shared/lib/const';
import { openForceDesktopVersion } from '#shared/lib/platform';
import styles from './Footer.module.css';

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <VStack className={styles.root}>
            <div className={styles.fullVersionBlock} role="button" tabIndex={0} onClick={openForceDesktopVersion}>
                <VStack gap="4" alignItems="center">
                    <IconDesktop role="supplementary" size="16" color="gray" />
                    <Text role="supplementary" size="xs" color="gray">
                        <Link color="supplementary" onClick={openForceDesktopVersion}>
                            Открыть полную версию страницы
                        </Link>
                    </Text>
                </VStack>
            </div>
            <PageFooter
                withSeparator
                mainItems={[
                    {
                        key: 'help',
                        content: (
                            <Text role="supplementary" size="xs" color="gray">
                                <Link color="supplementary" href={KIT_SUPPORT_URL} target="_blank" rel="noreferrer">
                                    Справка
                                </Link>
                            </Text>
                        ),
                    },
                ]}
                additionalItems={[
                    {
                        key: 'legal',
                        content: (
                            <Text role="supplementary" size="xs" color="gray">
                                © 2001–{currentYear} ООО «ЯНДЕКС»
                            </Text>
                        ),
                    },
                ]}
            />
        </VStack>
    );
};
